import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-motion-speed',
  templateUrl: './motion-speed.component.html',
  styleUrls: ['./motion-speed.component.sass']
})
export class MotionSpeedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
